module.exports = __webpack_public_path__ + "static/img/rental_success.295d2970.png";